var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalisys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.832031,
    y: 0.166504,
    width: 7.33333,
    height: 24.75,
    rx: 1.83333,
    fill: "#044D9F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.99805,
    y: 4.75,
    width: 7.33333,
    height: 20.1667,
    rx: 1.83333,
    fill: "#5487C1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.166,
    y: 9.33301,
    width: 7.33333,
    height: 15.5833,
    rx: 1.83333,
    fill: "#044D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalisys);
export default __webpack_public_path__ + "static/media/analisys.d81306aa89857e584c898ffd89dabd4f.svg";
export { ForwardRef as ReactComponent };